import { useTranslation } from 'react-i18next'
import { EditorErrorBoundary } from './error-handling'
import { MockFeedAd } from './new-mode-simulators/mock-feed-ad'
import { ScreenHeader } from './screen-header'

export function NewModeSimulators() {
	const { t } = useTranslation('editor')
	return (
		<div className="flex flex-col w-full items-center py-20 pr-20 gap-24 relative">
			<div id="resource-feed-ads">
				<ScreenHeader title={t('screenHeaders.feedAdPreview')} />
				<EditorErrorBoundary debugId="feed-ad">
					<MockFeedAd />
				</EditorErrorBoundary>
			</div>
		</div>
	)
}
